import { render, staticRenderFns } from "./Sandbox.vue?vue&type=template&id=7c5cda9c&scoped=true&"
import script from "./Sandbox.vue?vue&type=script&lang=ts&"
export * from "./Sandbox.vue?vue&type=script&lang=ts&"
import style0 from "./Sandbox.vue?vue&type=style&index=0&id=7c5cda9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5cda9c",
  null
  
)

export default component.exports